/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Severity level of the activity event
 * @export
 */
export const ActivityEventSeverity = {
    Info: 'info',
    Warning: 'warning',
    Error: 'error',
    Success: 'success'
} as const;
export type ActivityEventSeverity = typeof ActivityEventSeverity[keyof typeof ActivityEventSeverity];


export function instanceOfActivityEventSeverity(value: any): boolean {
    for (const key in ActivityEventSeverity) {
        if (Object.prototype.hasOwnProperty.call(ActivityEventSeverity, key)) {
            if (ActivityEventSeverity[key as keyof typeof ActivityEventSeverity] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ActivityEventSeverityFromJSON(json: any): ActivityEventSeverity {
    return ActivityEventSeverityFromJSONTyped(json, false);
}

export function ActivityEventSeverityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityEventSeverity {
    return json as ActivityEventSeverity;
}

export function ActivityEventSeverityToJSON(value?: ActivityEventSeverity | null): any {
    return value as any;
}

export function ActivityEventSeverityToJSONTyped(value: any, ignoreDiscriminator: boolean): ActivityEventSeverity {
    return value as ActivityEventSeverity;
}

